import { gql } from '@apollo/client'

export const createJobRequestCommentMutation = gql`
    mutation createJobRequestCommentMessagesUIQuality(
        $jobRequestCommentInput: JobRequestCommentInput!
    ) {
        createJobRequestComment(
            jobRequestCommentInput: $jobRequestCommentInput
        ) {
            id
            __typename
        }
    }
`
export const printVisualFictiv5Mutation = gql`
    mutation printVisualFictiv5Quality($id: Int!) {
        generateJobRequestVisualFictiv5(jobRequestId: $id)
    }
`

export const getJobRequestDetails = gql`
    query adminJobRequestQuery($id: Int!) {
        jobRequest(id: $id) {
            id
            jobId
            name
            rfqNumber
            salesOrderName
            payout
            vendorDueDate
            status
            productionStage
            createdAt
            mfgPartner {
                id
                name
            }
            project {
                id
                name
                isSecurePlus
            }
            inspectionStatus
            subjectTypes(category: QC_INVENTORY) {
                id
                value
            }
            jobRequestComments {
                id
                author {
                    id
                    firstName
                    lastName
                    email
                }
                subject
                body
                createdAt
                attachments {
                    id
                    fileName
                    url
                }
            }
            parts {
                id
                linesWithWorkOrderMapping {
                    id
                    name
                    partProduct {
                        id
                        colorName
                        partFileName
                        partProductRevision {
                            id
                            basicRevision {
                                sceneBundle
                                images {
                                    top
                                    angled
                                    side
                                    front
                                }
                                boundingBox {
                                    x
                                    y
                                    z
                                }
                            }
                        }
                    }
                    moldTool {
                        id
                        name
                        moldToolRevisionId
                    }
                    color {
                        id
                        name
                    }
                    drawingUri
                    productQty
                    inspectionType
                    processType
                    processName
                    processTexture
                    processThickness
                    platformProcessId
                    materialName
                    processNotes
                    processColor
                    jobRequestLineAttachments {
                        id
                        visibleToCustomer
                        attachment {
                            id
                            downloadUrl
                            fileName
                            extension
                            mimeType
                            uploadUrl
                        }
                        type
                        createdAt
                        workOrderItemName
                        createdBy {
                            id
                            displayName
                        }
                        source
                    }
                }
            }
            jobRequestAttachments {
                id
                attachment {
                    id
                    downloadUrl
                    fileName
                    extension
                    mimeType
                    uploadUrl
                }
                type
            }
        }
    }
`

export const removeJobRequestAttachmentsMutation = gql`
    mutation removeJobRequestAttachmentJobRequestDetail($ids: [UUID!]!) {
        removeJobRequestAttachments(ids: $ids)
    }
`

export const updateVisibleToCustomerMutation = gql`
    mutation updateVisibleToCustomerQuality(
        $id: UUID!
        $visibleToCustomer: Boolean!
    ) {
        updateVisibleToCustomer(id: $id, visibleToCustomer: $visibleToCustomer)
    }
`

export const createJobRequestAttachmentsMutation = gql`
    mutation createJobRequestAttachmentsQuality(
        $attachmentInput: JobRequestLineAttachmentInput!
    ) {
        createJobRequestAttachments(input: $attachmentInput) {
            id
            attachment {
                id
                uploadUrl
                downloadUrl
                mimeType
                fileName
                extension
            }
            type
            createdAt
            workOrderItemName
            createdBy {
                id
                displayName
            }
            source
        }
    }
`
